<template>
  <div class="main-hero">
    <div class="hero-content">
      <h1>{{$store.getters.pageTitle}}</h1>
      <div class="input-group" v-if="$route.name == 'Search'">
        <div class="search-field-container">
          <fa icon="search" />
          <search class="input" />
        </div>
      </div>
    </div>
    <div
      class="hero-image"
      :style="{ backgroundImage: topImage, backgroundPosition: topImagePosition }"
    ></div>
  </div>
</template>

<script>
import search from "@/components/pages/search/SearchField";
export default {
  computed: {
    topImage() {
      return this.$store.getters.topImage;
    },
    topImagePosition() {
      return this.$store.getters.topImagePosition;
    }
  },
  components: {
    search
  }
};
</script>

<style lang="scss">
</style>